import { Stack, Typography } from '@mui/material';

interface Props {
  title: string;
  definition: string;
}

export const GlossaryItem = ({ title, definition }: Props) => {
  return (
    <Stack direction="column" sx={{ gap: 0.5 }}>
      <Typography variant="caption">{title}</Typography>
      <Typography variant="body3">{definition}</Typography>
    </Stack>
  );
};
